// Brillenhaus – Header-Menü: Mega-Panels beim Überfahren (Desktop) und Menü-Panel für Handy/Tablet,
// das aus dem Desktop-Menü aufgebaut wird.

const esc = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

/* ---------- Desktop: Mega-Panels ---------- */
function initDesktop() {
  const items = document.querySelectorAll('.bh-hnav__item--mega');
  items.forEach((item) => {
    if (item.dataset.bhReady) return;
    item.dataset.bhReady = 'true';
    const top = item.querySelector('.bh-hnav__top');
    let timer;
    const open = () => {
      clearTimeout(timer);
      document.querySelectorAll('.bh-hnav__item.is-open').forEach((other) => other !== item && other.classList.remove('is-open'));
      item.classList.add('is-open');
      top.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      timer = setTimeout(() => {
        item.classList.remove('is-open');
        top.setAttribute('aria-expanded', 'false');
      }, 140);
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bh-hnav__item.is-open').forEach((item) => item.classList.remove('is-open'));
  });
}

/* ---------- Handy/Tablet: Menü-Panel ---------- */
function buildDrawer(drawer) {
  const list = drawer.querySelector('[data-bh-drawer-list]');
  const foot = drawer.querySelector('[data-bh-drawer-foot]');
  if (!list || list.dataset.built) return;
  list.dataset.built = 'true';

  const chevron =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  let cta = null;

  document.querySelectorAll('.bh-hnav__bar .bh-hnav__item').forEach((item) => {
    const ctaLink = item.querySelector('.bh-hnav__cta');
    if (ctaLink) {
      cta = { href: ctaLink.getAttribute('href'), text: ctaLink.textContent.trim() };
      return;
    }
    const top = item.querySelector('.bh-hnav__top');
    if (!top) return;
    const title = top.textContent.trim();
    const href = top.getAttribute('href');
    const li = document.createElement('li');

    if (item.classList.contains('bh-hnav__item--mega')) {
      const cols = [...item.querySelectorAll('.bh-hnav__col')]
        .map((col) => {
          const heading = col.querySelector('.bh-hnav__heading')?.textContent.trim();
          const links = [...col.querySelectorAll('a')]
            .map((a) => `<li><a href="${esc(a.getAttribute('href'))}">${esc(a.textContent.trim())}</a></li>`)
            .join('');
          return `<div class="bh-drawer__group">${heading ? `<p class="bh-drawer__heading">${esc(heading)}</p>` : ''}<ul role="list">${links}</ul></div>`;
        })
        .join('');
      const promos = [...item.querySelectorAll('.bh-hnav__promo')]
        .map((promo) => {
          const img = promo.querySelector('img');
          return `<a class="bh-drawer__promo" href="${esc(promo.getAttribute('href'))}">${
            img ? `<img src="${esc(img.currentSrc || img.src)}" alt="" loading="lazy">` : ''
          }<span>${esc(promo.querySelector('.bh-hnav__promo-label')?.textContent.trim() || '')}</span></a>`;
        })
        .join('');
      const allText = item.querySelector('.bh-hnav__all')?.textContent.replace('→', '').trim();
      li.innerHTML = `
        <details class="bh-drawer__details">
          <summary>${esc(title)}${chevron}</summary>
          <div class="bh-drawer__body">
            ${promos ? `<div class="bh-drawer__promos">${promos}</div>` : ''}
            ${cols}
            ${allText ? `<a class="bh-drawer__all" href="${esc(href)}">${esc(allText)} →</a>` : ''}
          </div>
        </details>`;
    } else {
      li.innerHTML = `<a class="bh-drawer__link" href="${esc(href)}">${esc(title)}</a>`;
    }
    list.appendChild(li);
  });

  // Fußbereich: Termin-Button und Kontaktdaten aus der Service-Leiste
  const parts = [];
  if (cta) parts.push(`<a class="bh-drawer__cta" href="${esc(cta.href)}">${esc(cta.text)}</a>`);
  document.querySelectorAll('.bh-topbar__utility a').forEach((a) => {
    parts.push(`<a class="bh-drawer__meta" href="${esc(a.getAttribute('href'))}">${a.innerHTML}</a>`);
  });
  foot.innerHTML = parts.join('');

  // Nur eine Rubrik gleichzeitig offen
  list.addEventListener('toggle', (event) => {
    if (!event.target.open) return;
    list.querySelectorAll('details[open]').forEach((d) => d !== event.target && (d.open = false));
  }, true);
}

function initDrawer() {
  const drawer = document.getElementById('bh-drawer');
  if (!drawer || drawer.dataset.bhReady) return;
  drawer.dataset.bhReady = 'true';
  // Außerhalb des Headers einhängen, damit das Panel unabhängig vom Sticky-Header über allem liegt
  document.body.appendChild(drawer);
  const toggles = document.querySelectorAll('[data-bh-drawer-open]');
  const panel = drawer.querySelector('.bh-drawer__panel');

  const open = () => {
    buildDrawer(drawer);
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.documentElement.classList.add('bh-scroll-lock');
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    panel.focus({ preventScroll: true });
  };
  const close = () => {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('bh-scroll-lock');
    toggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    setTimeout(() => (drawer.hidden = true), 280);
  };

  toggles.forEach((t) => t.addEventListener('click', open));
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-bh-drawer-close]')) close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });
}

initDesktop();
initDrawer();
